import React, { Fragment, useCallback, useState } from "react";

import AddInventoryForm from "./AddInventoryForm";

const AddInventory = ({
    handleFileUpload,
    locationsUploading,
}) => {
    const [file, setFile] = useState(null);

    const handleSubmit = useCallback(
        (event) => {
            event.preventDefault();
            handleFileUpload(file.files[0]);
        },
        [handleFileUpload, file]
    );

    return (
        <Fragment>
            <AddInventoryForm
                validated={false}
                handleSubmit={handleSubmit}
                file={file}
                setFile={setFile}
                locationsUploading={locationsUploading}
            />
        </Fragment>
    );
};

export default AddInventory;
